import { ColorEnum } from '@/constants/color'
import ChevronDownIcon from '@/features/ui/icons/components/ChevronDownIcon'
import { FC } from 'react'

const ChevronUpIcon: FC = () => {
    return (
        <ChevronDownIcon
            height={16}
            width={16}
            color={ColorEnum.BRICK_700}
            style={{ transform: [{ rotate: '180deg' }] }}
        />
    )
}

export default ChevronUpIcon
